<template>
    <div>  
        <div v-if="(value===0)" class='job-state-success'><i class='fa fa-check'/>&nbsp;{{L("job_state_ok")}}</div>
        <div v-if="(value===1)" class='job-state-failed'><i class='fa fa-exclamation error'/>&nbsp;{{L("job_state_error")}}</div>
        <div v-if="(value===2)">{{L("job_state_running")}}</div>
        <div v-if="(value===3)">{{L("job_state_enqueued")}}</div>
    </div>
</template>
<script>
export default {
  props: ["value"]  
  };
</script>
<style scoped>
.job-state-success {
  color: green;
}
.job-state-failed {
  color: red;
}
</style>
